export default [
  {
    key: '1',
    candidate: 'Jose da silva',
    type: 'Entrevista técnica',
    status: 'Completed',
    date: '10/10/2010',
    interviewer: 'Valter Jr',
    finalScore: 3.5,
    creator: 'Litza',
    lastUpdate: '10/10/2010 11:50 by Sara',
  }, {
    key: '2',
    candidate: 'Maria',
    type: 'Entrevista Inicial',
    status: 'Pendente',
    date: '10/10/2010',
    interviewer: 'Valter Jr',
    finalScore: 3.5,
    creator: 'Litza',
    lastUpdate: '10/10/2010 11:50 by Sara',
  }, {
    key: '3',
    candidate: 'Jose da silva',
    type: 'Entrevista técnica',
    status: 'Completed',
    date: '10/10/2010',
    interviewer: 'Valter Jr',
    finalScore: 3.5,
    creator: 'Litza',
    lastUpdate: '10/10/2010 11:50 by Sara',
  }, {
    key: '4',
    candidate: 'Jose da silva',
    type: 'Entrevista técnica',
    status: 'Completed',
    date: '10/10/2010',
    interviewer: 'Valter Jr',
    finalScore: 3.5,
    creator: 'Litza',
    lastUpdate: '10/10/2010 11:50 by Sara',
  },
];



// WEBPACK FOOTER //
// ./src/mock/interviews.js